import React, { useState, useEffect } from "react";
import NavHeader from "../../Common/NavHeader";
import BreadCrumb from "../../Common/BreadCrumb";
import { uploadReportFile, getUploadInstructions, getScrapperProcesses } from "../api";
import useAppStore from "../../../store/global";
import { Spinner } from "react-bootstrap";
import { useParams, useLocation} from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Uploader from "./uploader";

export default function UploadHome() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const restName = queryParams.get('restaurant_name');

  const { loading, setLoading } = useAppStore();
  const { id } = useParams();
  const [instructions, setInstructions] = useState("");
  const [instructionLoading, setInstructionLoading] = useState(false);
  const [scrapperProcesses, setScrapperProcesses] = useState([]);

  const fetchInstructions = (body) => {
    setInstructionLoading(true);
    getUploadInstructions(body)
      .then((data) => {
        setInstructions(data.message);
        setInstructionLoading(false);
      })
      .catch((err) => {
        console.log("errorr", err);
        setInstructionLoading(false);
      });
  };

  const getScrapperProcessesData = (page_index, page_size) => {
    setLoading(true);
    getScrapperProcesses(page_index, page_size, id)
      .then((data) => {
        setScrapperProcesses(data.scrapper_processes);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  }

  const handleUpload = (body) => {
    setLoading(true);
    uploadReportFile(body)
      .then((res) => {
        toast.success(res.message);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
        toast.error(err.response.data.message);
      });
  };

  useEffect(() => {
    getScrapperProcessesData(1, 10);
  }, 
  // eslint-disable-next-line
  []);

  return (
    <>
      <NavHeader view="scrapper" />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb text={`Restaurants > ${restName} >  Upload Report Manually`} />
        {loading ? (
          <div className="text-center mt-5">
            <Spinner animation="border" />
          </div>
        ) :
        <>
          <Uploader
            instructions={instructions}
            instructionLoading={instructionLoading}
            handleUpload={handleUpload}
            fetchInstructions={fetchInstructions}
            scrapperProcesses={scrapperProcesses}
          />
          {/* <ToastContainer /> */}
        </>
        }
         <ToastContainer />
      </div>
    </>
  );
}
